import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconText = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 0V5.625H0.9375L2.8125 2.8125H5.625V12.1875L2.8125 14.0625V15H12.1875V14.0625L9.375 12.1875V2.8125H12.1875L14.0625 5.625H15V0H0Z",
		fill: "currentColor"
	})
});
export default SvgIconText;
